import { createFileRoute } from "@tanstack/react-router";
import { HelpTip } from "~/components/ui/help-tip";
import { PrintingSettings } from "~/features/settings/print-agents";

export const Route = createFileRoute("/_app/settings/printing")({ component: PrintingSettingsPage });

function PrintingSettingsPage() {
  return (
    <>
      <div className="mb-5 flex items-start gap-1">
        <HelpTip id="settings.printing" />
      </div>
      <PrintingSettings />
    </>
  );
}
